import { getSnapshot, Instance, SnapshotOut, types } from 'mobx-state-tree';
import { isDemoDomain } from 'src/utils/common';

import { CommonCodeApi, TGetCommonCodesResult, TGetTempPwResult } from '../../services';
import { CommonCode, ICommonCode } from '../common-code/CommonCode';
import { withEnvironment } from '../extensions/with-environment';
import { withRootStore } from '../extensions/with-root-store';

/**
 * # CommonCodeStore
 *
 * CommonCodeStore을 설명하세요.
 */
export const CommonCodeStore = types
  .model('CommonCodeStore')
  // --------------------------------------------------------------------------
  .props({
    commonCodes: types.optional(types.array(CommonCode), []),
    dynamicCodes: types.optional(types.array(CommonCode), []),
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  // eslint-disable-line @typescript-eslint/no-unused-vars
  .views((self) => ({
    getCCode() {
      return getSnapshot(self.commonCodes);
    },
    getCodeByName(name: string) {
      const found = self.commonCodes.find((v) => v.name === name);
      return found
        ? getSnapshot(found.list).map((v) => ({
            label: v.value ?? '',
            value: v.code ?? '',
          }))
        : [];
    },

    getCCodeByName(name: string) {
      let result: { code: string; value: string }[] = [];

      self.commonCodes.forEach((v) => {
        if (v.name === name) {
          result = getSnapshot(v.list).map((v) => {
            return {
              code: (v.code ?? '').toString(),
              value: v.value ?? '',
            };
          });
        }
      });

      return result;
    },

    getDCode() {
      return getSnapshot(self.dynamicCodes);
    },
    getDCodeByName(name: string) {
      let result: { code: string; value: string }[] = [];

      self.dynamicCodes.forEach((v) => {
        if (v.name === name) {
          result = getSnapshot(v.list).map((v) => {
            return {
              code: (v.code ?? '').toString(),
              value: v.value ?? '',
            };
          });
        }
      });

      return result;
    },

    // getCodeByPCode(pCode: number) {
    //   return this.getCodeByName(PcodeList[pCode.toString()]);
    // },
  }))
  // --------------------------------------------------------------------------
  // MUTATEs - 모델 상태를 변경
  .actions((self) => ({
    /**
     * commonCodes을 교체
     *
     * @param `commonCodes` 새로운 모델의 배열
     */
    setCommonCodes: (commonCodes: ICommonCode[]) => {
      // 원본 데이터로 설정
      self.commonCodes.replace(commonCodes);
      // 데모 환경이면 후처리로 수정
      if (isDemoDomain) {
        const partnerTypeGroup = self.commonCodes.find(
          (group) => group.name === 'PARTNER_TYPES_CD',
        );
        if (partnerTypeGroup) {
          partnerTypeGroup.list.forEach((code) => {
            if (code.code === 201201) {
              code.setProps({ value: '일반' });
            } else if (code.code === 201202) {
              code.setProps({ value: '협력' });
            }
          });
          // MSP/AP 제거 (뒤에서부터 제거해야 인덱스 꼬임 방지)
          for (let i = partnerTypeGroup.list.length - 1; i >= 0; i--) {
            const code = partnerTypeGroup.list[i];
            if (!['201201', '201202'].includes(code.code?.toString() || '')) {
              partnerTypeGroup.list.remove(code);
            }
          }
        }
      }
    },
    setDynamicCodes: (dynamicCodes: ICommonCode[]) => {
      self.dynamicCodes.replace(dynamicCodes);
    },
  }))
  // --------------------------------------------------------------------------
  // REQUESTs - 서비스 요청 및 기타 인터페이스 요청
  .actions((self) => ({
    /**
     * 코드 조회
     */
    getsCommon: async () => {
      const commonCodeApi: CommonCodeApi = new CommonCodeApi(self.environment.api);
      const result: TGetCommonCodesResult = await commonCodeApi.getsCommon();
      if (result.kind === 'ok') {
        self.setCommonCodes(result.codes);
      } else {
        console.error(result.kind);
      }
    },

    /**
     * 동적 코드 조회
     */
    getsDynamic: async () => {
      const commonCodeApi: CommonCodeApi = new CommonCodeApi(self.environment.api);
      const result: TGetCommonCodesResult = await commonCodeApi.getsDynamic();
      if (result.kind === 'ok') {
        self.setDynamicCodes(result.codes);
      } else {
        console.error(result.kind);
      }
    },

    getTempPw: async () => {
      const commonCodeApi: CommonCodeApi = new CommonCodeApi(self.environment.api);
      const result: TGetTempPwResult = await commonCodeApi.getTempPw();
      if (result.kind === 'ok') {
        // result.data && self.setCommonCodes(result.data);
      } else {
        console.error(result.kind);
      }
    },
  }));

// --------------------------------------------------------------------------
type TCommonCodeStore = Instance<typeof CommonCodeStore>;
type TCommonCodeStoreSnapshot = SnapshotOut<typeof CommonCodeStore>;

export interface ICommonCodeStore extends TCommonCodeStore {}
export type TCommonCodeStoreKeys = keyof TCommonCodeStoreSnapshot & string;
export interface ICommonCodeStoreSnapshot extends TCommonCodeStoreSnapshot {}
export const createCommonCodeStore = () => types.optional(CommonCodeStore, {} as TCommonCodeStore);
